<script>
    import {mapState, mapActions} from 'vuex';
    import Vue from 'vue';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";
    import {size} from 'lodash';

    export default {
        name: "CourseContentsComponent",
        data () {
            return {
                componentType: "course-contents",
                rendersWithVue: true,
                sectionsToggledDisplay: {},
                slideIndex: 0
            }
        },
        mixins: [
            AnimationsMixin
        ],
        computed: {
            ...mapState('products',[
                'courses',
                'fetchingCourseContents'
            ]),
            ...mapState('UiInteractions',[
                'activeDevicePreview'
            ]),
            availableTemplates () {
                return [
                    {
                        "templateFilename" : "CourseContentsTemplate1",
                        "forSectionTemplate" : "CourseContents1"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate2",
                        "forSectionTemplate" : "CourseContents2"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate3",
                        "forSectionTemplate" : "CourseContents3"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate3",
                        "forSectionTemplate" : "CourseContents4"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate5",
                        "forSectionTemplate" : "CourseContents5"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate6",
                        "forSectionTemplate" : "CourseContents6"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate7",
                        "forSectionTemplate" : "CourseContents7"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate8",
                        "forSectionTemplate" : "CourseContents8"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate9",
                        "forSectionTemplate" : "CourseContents9"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate10",
                        "forSectionTemplate" : "CourseContents10"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate11",
                        "forSectionTemplate" : "CourseContents11"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate12",
                        "forSectionTemplate" : "CourseContents12"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate13",
                        "forSectionTemplate" : "CourseContents13"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate14",
                        "forSectionTemplate" : "CourseContents14"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate15",
                        "forSectionTemplate" : "CourseContents15"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate16",
                        "forSectionTemplate" : "CourseContents16"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate17",
                        "forSectionTemplate" : "CourseContents17"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate18",
                        "forSectionTemplate" : "CourseContents18"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate19",
                        "forSectionTemplate" : "CourseContents19"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate20",
                        "forSectionTemplate" : "CourseContents20"
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate21",
                        "forSectionTemplate" : "CourseContents21",
                        "withSlider": true
                    },
                    {
                        "templateFilename" : "CourseContentsTemplate22",
                        "forSectionTemplate" : "CourseContents22",
                        "withSlider": true
                    }
                ]
            },
            selectedTemplateHasSlider () {
                return this.availableTemplates.find(templateData => this.myData.template === templateData.templateFilename && templateData.withSlider ) ? true : false;
            },
            getActionTriggerComponentsData () {
                return [
                    {
                        display:  this.canSlideBack,
                        template: "slider-back-arrow",
                        executableFunction : this.sliderArrowClicked
                    },
                    {
                        display:  this.canSlideForth,
                        template: "slider-forth-arrow",
                        executableFunction : this.sliderArrowClicked
                    },
                ]
            },
            visibleSectionsSettingsPerDevice () {
                if (this.activeDevicePreview === "desktop") {
                    return {
                        visibleSections: 4,
                        marginOffset: 25
                    };
                } else {
                    return {
                        visibleSections: 3,
                        marginOffset: 33
                    };
                }
            },
            canSlideForth () {
                return this.renderData.course && this.renderData.course.sections && this.slideIndex < size(this.renderData.course.sections) - this.visibleSectionsSettingsPerDevice.visibleSections;
            },
            canSlideBack () {
                return this.renderData.course && this.renderData.course.sections && size(this.renderData.course.sections) && this.slideIndex > 0;
            },
            getDefaultDataStructure () {
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: this.getDefaultTemplate,
                    selectedCourseTitleId: null,
                    displayAccessLabel: true,
                    styles: null,
                    itemVisibilitySettings: null
                }
            },
            getDefaultTemplate () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;
                let defaultTemplateData = this.availableTemplates.find(templateData => sectionTemplateId === templateData.forSectionTemplate);

                if (sectionState && defaultTemplateData) {
                    return defaultTemplateData.templateFilename;
                }

                return this.availableTemplates[0] ? this.availableTemplates[0].templateFilename : "";
            },
            myCourseData () {
                let courseFound = null;

                this.courses.map(course => {
                    if (course.titleId === this.selectedCourseTitleId) {
                        courseFound = course;
                    }
                })

                return courseFound;
            },
            selectedCourseTitleId () {
                const takeFromContext = this.isPageContext('course')
                    && this.pageContext.params
                    && this.courses.filter( course => course.titleId === this.pageContext.params.slug).length
                    && !this.componentData.selectedCourseTitleId;

                if (takeFromContext) {
                    this.changeMyData({
                        selectedCourseTitleId: this.pageContext.params.slug
                    })
                }

                if (this.componentData.selectedCourseTitleId) {
                    return this.componentData.selectedCourseTitleId;
                }

                return "";
            },

            displayAccessLabel () {
                if (this.componentData.hasOwnProperty('displayAccessLabel')) {
                    return this.componentData.displayAccessLabel;
                }
                return true;
            },

            renderData () {

                let selectedCourseTitleId = this.selectedCourseTitleId;

                if (selectedCourseTitleId && this.fetchingCourseContents.indexOf(selectedCourseTitleId) === -1 &&
                    ( !this.myCourseData || ( this.myCourseData && typeof this.myCourseData.sections === "undefined"))
                ) {
                    this.getCourseContents({courseId: selectedCourseTitleId, getParams: "author"});
                }

                let courseData = this.editCourseData(this.myCourseData);

                let renderData = {
                    course: courseData,
                    ...this.componentData
                }

                return renderData;
            },
        },
        methods: {
            ...mapActions('products',[
                'getCourseContents'
            ]),
            sliderArrowClicked (arrow) {
                let contentsHolder = this.getCourseContentsHolder();
                let existingMargin = this.sectionNode.querySelector(".js-course-contents-holder").style.marginLeft;

                if (arrow === "slider-back-arrow" && contentsHolder) {
                    this.slideIndex--;
                    existingMargin = existingMargin? parseInt(existingMargin) : 0;
                    contentsHolder.style.marginLeft = (existingMargin + this.visibleSectionsSettingsPerDevice.marginOffset) + "%";
                } else if (arrow === "slider-forth-arrow" && contentsHolder) {
                    this.slideIndex++;
                    existingMargin = existingMargin? parseInt(existingMargin) : 0;
                    contentsHolder.style.marginLeft = (existingMargin - this.visibleSectionsSettingsPerDevice.marginOffset) + "%";
                }
            },
            resetSlider () {
                let contentsHolder = this.getCourseContentsHolder();

                if (contentsHolder) {
                    this.slideIndex = 0;
                    contentsHolder.style.marginLeft = 0;
                }
            },
            getCourseContentsHolder () {
                return this.componentNode.querySelector(".js-course-contents-holder");
            },
            handleActionTrigger (componentName) {
                this.getActionTriggerComponentsData.find( data => {
                    if(data.template === componentName && data.executableFunction) {
                        data.executableFunction.call(null,componentName);
                        return true;
                    }
                })
            },
            editCourseData (course) {
                // console.log("editing course data with : " , course)
                if (!course || (course && !course.sections)) {
                    return course;
                }

                let clonedData = copyJson(course);

                for (let sectionTitleId in clonedData.sections) {
                    if (!clonedData.sections.hasOwnProperty(sectionTitleId)){
                        continue;
                    }

                    let sectionData = clonedData.sections[sectionTitleId];

                    if (this.blockSectionRendering(sectionData)) {
                        delete clonedData.sections[sectionTitleId];
                    }

                    for (let unitIndex in sectionData.learningPath) {
                        if (!sectionData.learningPath.hasOwnProperty(unitIndex)) {
                            continue;
                        }

                        let unitData = sectionData.learningPath[unitIndex];

                        if (unitData.type === "ivideo" && clonedData.videos[unitData.id]) {
                            unitData.title = clonedData.videos[unitData.id].title;
                        } else if (unitData.type === "ebook" && clonedData.ebooks[unitData.id])  {
                            unitData.title = clonedData.ebooks[unitData.id].title;
                        } else if (clonedData.objects[unitData.id]) {
                            unitData.title = clonedData.objects[unitData.id].title;
                        }


                    }
                }
                return clonedData;
            },
            setSectionToggledDisplay (titleId,value) {
                Vue.set(this.sectionsToggledDisplay,titleId, value);
            },
            blockSectionRendering (sectionData) {
                return sectionData.access === 'private';
            },
            sectionIsDripLocked (sectionTitleId) {
                return  this.myCourseData && this.myCourseData.me && typeof this.myCourseData.me.drip !== "undefined" &&
                        typeof this.myCourseData.me.drip.sections !== "undefined" &&
                        typeof this.myCourseData.me.drip.sections[sectionTitleId] !== "undefined" &&
                        this.myCourseData.me.drip.sections[sectionTitleId].status !== "opened"

            },
            getSelectedCourse () {
                return this.selectedCourseTitleId;
            },
            setSelectedCourse (eventData) {
                this.changeMyData({
                    selectedCourseTitleId: eventData.value
                });
                this.setChangesAreSaved(false);
            },
            getDisplayAccessLabel () {
                return this.displayAccessLabel;
            },
            setDisplayAccessLabel (value) {
                this.changeMyData({
                    displayAccessLabel: value
                });
                this.setChangesAreSaved(false);
            }
        },
        watch: {
            activeDevicePreview () {
                if (this.selectedTemplateHasSlider) {
                    this.resetSlider();
                }
            },
            selectedCourseTitleId () {
                if (this.selectedTemplateHasSlider) {
                    this.resetSlider();
                }
            }
        }
    }
</script>
